export default __webpack_public_path__ + "assets/smoke.14e1644a.svg";